import { Button, Row, Col } from "react-bootstrap";
import outlookIcon from "../../assets/images/icon_outlook_365.svg";

import Header from "../../../src/components/Header";
import Footer from "../../../src/components/Footer";

import { useAppContext } from "../../components/AppContext";
import { Navigate } from "react-router-dom";

export default function Login() {
  const { user } = useAppContext();
  const app = useAppContext();

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Header />
      <section className="container-fluid content-login centro-vertical text-center bg-celeste">
        <Row className="justify-content-center" id="login-panel">
          <Col md={8} sm={8} className="mx-2 marco-user">
            <Row style={{ minHeight: "300px" }}>
              <Col md={7} sm={12} className="marco-login p-4 bg-blanco">
                <h2
                  className="br-bottom-1px gris"
                  style={{ fontSize: "1.3rem", textTransform: "uppercase" }}
                >
                  Iniciar sesión
                </h2>
                <div className="centro-vertical" style={{ height: "80%" }}>
                  <Button
                    className="btn btn-outlook"
                    style={{ fontSize: "0.95rem" }}
                    title="Ingresar con mi correo @iosfa.gob.ar"
                    onClick={app.signIn!}
                  >
                    <img
                      src={outlookIcon}
                      className="pr-1"
                      alt="Ingresar con mi cuenta @iosfa.gob.ar"
                      height="60px"
                    />
                    <br />
                    Ingresar
                  </Button>
                  <h6 className="pt-4 font-weight-normal gris">
                    Accedé con tu cuenta @iosfa.gob.ar
                  </h6>
                  {/* <h6 className="font-weight-normal gris">
                    Si ya iniciaste sesión en correo.iosfa.gob.ar te
                    redireccionaremos automáticamente.
                  </h6> */}
                </div>
                <div className="form-response"></div>
              </Col>
              <Col md={5} sm={12} className="p-4 parrafo-user">
                <div>
                  <h3 style={{ fontSize: "1.25rem" }}>¡Hola!</h3>
                  <p className="text-left font-weight-bold gris">
                    La Grilla IOSFA es una aplicación web donde vas a poder
                    consultar sobre todos/as los/as funcionarios/as que trabajamos en IOSFA
                    {/*, la orgánica institucional*/}, el organigrama y los establecimientos propios.
                  </p>
                  <hr />
                  <p className="text-left mb-0">
                    Para iniciar sesión hacé click en el botón{" "}
                    <span className="blue-web font-weight-bold">
                      Ingresar con mi correo @iosfa.gob.ar
                    </span>{" "}
                    y serás redirigido al formulario de ingreso al correo
                    institucional.
                    <br />
                    <small className="font-weight-bold">
                      * Si no tenés cuenta de correo institucional, contactá a
                      tu superior inmediato para que la solicite a la Gerencia
                      de Sistemas y Tecnología Informática.
                    </small>
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
      <Footer />
    </>
  );
}
